// extracted by mini-css-extract-plugin
export default {"arrowIcon":"dVkVf7"};